export const NEWBUILDING_ADFOX_SITE_JK_DESKTOP = 'newbuilding_adfox_site_jk_desktop';

export const NEWBUILDING_TRUST_AND_SAFETY = 'newbuilding_trust_safety_desktop';

export const NEWBUILDING_KPN_CHAT = 'newbuilding_kpn_chats_jk_desktop';

export const EXPERIMENTS = [NEWBUILDING_ADFOX_SITE_JK_DESKTOP, NEWBUILDING_TRUST_AND_SAFETY, NEWBUILDING_KPN_CHAT];
